import { IProjectPositionSearchResponse } from '../interfaces/projectPostitionSearch';
import { IProjectPositionStringSkills } from '../interfaces/projectPosition';

export const getProjectPositionFromSearchResponse = (searchResponse: IProjectPositionSearchResponse): IProjectPositionStringSkills => ({
  id: searchResponse.id,
  positionId: searchResponse.positionId,
  roleId: searchResponse.roleId,
  status: searchResponse.status,
  skills: searchResponse.skills,
  description: searchResponse.positionDescription,
  title: searchResponse.positionTitle,
  preferredRate: searchResponse.rate,
  positionName: searchResponse.positionName,
  projectOpportunityId: searchResponse.projectOpportunityId,
  availability: {
    fromHour: searchResponse.availabilityFromHour,
    toHour: searchResponse.availabilityToHour,
    availabilityType: searchResponse.availabilityType,
    timezone: searchResponse.timezone
  },
  createdOn: searchResponse.auditDetails.createdOn,
  link: searchResponse.link,
  language: {
    languageCode: searchResponse.languageCode,
    minimumProficiencyLevel: searchResponse.languageProficiencyLevel
  },
  roleName: searchResponse.roleName
});